import {createClient} from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID
const dataset = process.env.REACT_APP_SANITY_DATASET

export const sanityEnabled = Boolean(projectId && dataset)

export const sanityClient = sanityEnabled
    ? createClient({
          projectId,
          dataset,
          apiVersion: '2024-01-01',
          useCdn: true,
      })
    : null

const builder = sanityClient ? imageUrlBuilder(sanityClient) : null

export const urlFor = (source) => {
    if (!builder || !source) return null
    return builder.image(source)
}
